import Grid from './components/Grid';
function App() {
  return (
    <div>
      <Grid />
    </div>
  );
}

export default App;

